import { React } from "react";

const Benefits = () => {
  return (
    <>
      <section className="benefits mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h2>Why Choose Us</h2>
              <h1>Benefits you get when you join our courses</h1>
            </div>
            <div className="col-md-6">
              <div className="benefit-single row">
                <div className="col-sm-1">
                  <h3>01.</h3>
                </div>
                <div className="col-sm-11">
                  <h3>Practical lesson match with standard industry</h3>
                </div>
                <div className="col-sm-1"></div>
                <div className="col-sm-10">
                  <p>
                    We provide you our best network that we owned to engage your
                    product to get more (...)
                  </p>
                </div>
                <div className="col-sm-1">
                  <span className="fa fa-chevron-right"></span>
                </div>
              </div>
              <div className="benefit-single row">
                <div className="col-sm-1">
                  <h3>02.</h3>
                </div>
                <div className="col-sm-11">
                  <h3>High-quality lessons taught by experts in their field</h3>
                </div>
                <div className="col-sm-1"></div>
                <div className="col-sm-10">
                  <p>
                    We provide you our best network that we owned to engage your
                    product to get more (...)
                  </p>
                </div>
                <div className="col-sm-1">
                  <span className="fa fa-chevron-right"></span>
                </div>
              </div>
              <div className="benefit-single bottom-border row">
                <div className="col-sm-1">
                  <h3>03.</h3>
                </div>
                <div className="col-sm-11">
                  <h3>Unlimited time access with affordable prices</h3>
                </div>
                <div className="col-sm-1"></div>
                <div className="col-sm-10">
                  <p>
                    We provide you our best network that we owned to engage your
                    product to get more (...)
                  </p>
                </div>
                <div className="col-sm-1">
                  <span className="fa fa-chevron-right"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="clearfix"></div>
    </>
  );
};
export default Benefits;
